<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>{{ $t('communityManage.confirmRecallAudit') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="recallAuditFinishCommunity">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { recallAudit } from '@/api/common/communityManage/communityManageApi'

export default {
  name: 'RecallAuditFinishCommunity',
  data() {
    return {
      dialogVisible: false,
      recallAuditFinishCommunityInfo: {}
    }
  },
  methods: {
    open(community) {
      this.dialogVisible = true
      this.recallAuditFinishCommunityInfo = { ...community }
    },
    handleClose() {
      this.recallAuditFinishCommunityInfo = {}
    },
    recallAuditFinishCommunity() {
      const params = {
        communityId: this.recallAuditFinishCommunityInfo.communityId,
        state: '1000',
        remark: this.$t('communityManage.recallAuditRemark')
      }

      recallAudit(params).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t('communityManage.recallSuccess'))
          this.dialogVisible = false
          this.$emit('recalled')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        console.error('请求失败:', error)
        this.$message.error(this.$t('communityManage.recallFailed'))
      })
    }
  }
}
</script>

<style scoped>
.el-dialog__body {
  padding: 20px;
}
</style>